import { useEffect, useState } from "react";
import { ProductCard } from "@/components/ProductCard";
import { productBySlug } from "@/lib/shopCatalog";
import { getRecentSlugs } from "@/lib/recentlyViewed";

export const RecentlyViewed = ({ excludeSlug, limit = 4, className = "px-5 lg:px-10 py-12 border-t border-white/10" }) => {
  const [slugs, setSlugs] = useState([]);
  useEffect(() => {
    setSlugs(getRecentSlugs());
  }, [excludeSlug]);
  const products = slugs.filter((s) => s !== excludeSlug).map(productBySlug).filter(Boolean).slice(0, limit);
  if (products.length === 0) return null;
  const colClass =
    { 1: "sm:max-w-sm", 2: "sm:grid-cols-2 lg:max-w-3xl", 3: "sm:grid-cols-2 lg:grid-cols-3 lg:max-w-5xl" }[products.length] ||
    "sm:grid-cols-2 lg:grid-cols-4";
  return (
    <section className={className} data-testid="recently-viewed">
      <p className="font-mono-label text-white/40">PICK UP WHERE YOU LEFT OFF</p>
      <h2 className="font-display text-3xl lg:text-4xl mt-2">RECENTLY VIEWED.</h2>
      <div className={`grid grid-cols-1 ${colClass} gap-px bg-white/10 border border-white/10 mt-8`}>
        {products.map((p) => (
          <ProductCard key={p.slug} p={p} listId="recently-viewed" listName="Recently Viewed" />
        ))}
      </div>
    </section>
  );
};
